import React, { useState } from "react";
import { Icon, Button, notification } from "antd";
import moment from "moment";
import axios from "axios";

import ModalLoading from "../../../../shared/components/Modals/ModalLoading";
import ModalViewer from "../../../../shared/components/Modals/ModalViewer";
//import DrawerEstudoGerarPdf from "../Drawers/DrawerEstudoGerarPdf";

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const EstudoIranduba = ({ onEdit, onEditPreEscola, onView, onViewPreEscola, onPdf, estudo }) => {
    const { id, tipo, data_registro, nome, descricao } = estudo;

    const isPreEscola = tipo === "estudo_caso_infantil_pre_escola";

    const [modalVisible, setModalVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [docs, setDocs] = useState([]);

    const [visible, setVisible] = useState(false);

    const gerarPdf = () => {
        setIsLoading(true);
        axios({
            method: "get",
            url: "api/pdf/formulario-caso",
            params: {
                id
            }
        })
            .then(response => {
                const { url, fileName } = response.data;

                setDocs([{ uri: url, fileName }]);
                setModalVisible(true);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível gerar documento.");
            })
            .finally(() => setIsLoading(false));
    };

    const handleCloseDrawerPdf = () => {
        setVisible(false);
    };

    const [drawerPdfVisible, setDrawerPdfVisible] = useState(false);
    const [documentoId, setDocumentoId] = useState(null);

    const abrirDrawerPdf = idDocumento => {
        setDocumentoId(idDocumento);
        setDrawerPdfVisible(true);
    };

    const fecharDrawerPdf = () => {
        setDrawerPdfVisible(false);
        setDocumentoId(null);
    };

    return (
        <>
            <div className="plano-atendimento-item">
                <div className="plano-atendimento-item-info">
                    <div>
                        <Icon type="file-text" />
                        {isPreEscola ? "Estudo de Caso Pré-Escola" : "Estudo de Caso Creche"}
                    </div>
                    <p>Data: {moment(data_registro).format("DD/MM/YYYY")}</p>
                    {nome && <p>Estudante: {nome}</p>}
                    {descricao && <p className="item-descricao">{descricao}</p>}
                </div>
                <div className="plano-atendimento-item-opcoes">
                    {isPreEscola ? (
                        <>
                            <Button onClick={() => onViewPreEscola(id)}>
                                <Icon type="eye" />
                                Visualizar
                            </Button>
                            <Button onClick={() => onEditPreEscola(id)}>
                                <Icon type="edit" />
                                Editar
                            </Button>
                            <Button onClick={() => gerarPdf()}>
                                <Icon type="download" />
                                PDF
                            </Button>
                        </>
                    ) : (
                        <>
                            <Button onClick={() => onView(id)}>
                                <Icon type="eye" />
                                Visualizar
                            </Button>
                            <Button onClick={() => onEdit(id)}>
                                <Icon type="edit" />
                                Editar
                            </Button>
                            <Button onClick={() => gerarPdf()}>
                                <Icon type="download" />
                                PDF
                            </Button>
                        </>
                    )}
                </div>
            </div>
            <ModalLoading visible={isLoading} text="A gerar documento..." />
            <ModalViewer visible={modalVisible} docs={docs} onCancel={() => setModalVisible(false)} />

            {/* <DrawerEstudoGerarPdf visible={drawerPdfVisible} onClose={fecharDrawerPdf} documentoId={documentoId} /> */}
        </>
    );
};

export default EstudoIranduba;
